import React from 'react';
import { Add } from '@material-ui/icons';
import { Container, GlobalActions } from '@michelin/acid-components';
import { usePermissions, useTranslation } from '@michelin/central-provider';
import { PlainMessage } from 'components/Messages';
import { SpeedDial, SpeedDialActions } from 'components/SpeedDial';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';
import { TireProfileList } from 'modules/Tires/List/List';
import { WheelsModule } from 'modules/Wheels/List';
import { getBaseUrl } from 'prefs-and-service-offers';
import { useHistory } from 'react-router-dom';

export function TireWheelModule() {
  const { t } = useTranslation();
  const history = useHistory();
  const permissions = usePermissions();

  // Urban-only fleets were never exposed to Wheels or Mechanical under the
  // legacy Fleet Order service offer. Enforce the same restriction here.
  const urbanOnlyFleet = !!(
    permissions.location &&
    permissions.location.is_urban &&
    !permissions.location.is_commercial &&
    !permissions.location.override_is_commercial
  );

  const canViewTire = permissions.allowsAction('tires.list') && permissions.allowsAction('tires.read');
  const canViewWheel =
    !urbanOnlyFleet && permissions.allowsAction('wheels.list') && permissions.allowsAction('wheels.read');
  const canCreateTire = canViewTire && permissions.allowsAction('tires.create');
  const canCreateWheel = canViewWheel && permissions.allowsAction('wheels.create');

  // Single create control: let the user pick whether to add a tire or a wheel
  // profile, only offering the options they are permitted to create.
  const createActions: SpeedDialActions[] = [];
  if (canCreateWheel) {
    createActions.push({
      icon: <Add />,
      title: t('Wheel Profile'),
      name: 'Wheel Profile',
      id: 'create-wheel-profile',
      titleOpen: true,
      onClick: () => history.push(`${getBaseUrl()}/wheel-details/create`),
    });
  }
  if (canCreateTire) {
    createActions.push({
      icon: <Add />,
      title: t('Tire Profile'),
      name: 'Tire Profile',
      id: 'create-tire-profile',
      titleOpen: true,
      onClick: () => history.push(`${getBaseUrl()}/tire-profile/create`),
    });
  }

  return (
    <>
      <PageTitle
        eyebrow={t('Preferences')}
        title={t('Tire & Wheel Preferences')}
        subtitle={t('Manage Preferences for Tire & Wheel Services.')}
      />
      <Container>
        {canViewTire ? (
          <TireProfileList hideGlobalActions />
        ) : (
          <PlainMessage
            title={t('Tire Preferences unavailable')}
            messages={[t('Your account does not have permission to view tire preferences.')]}
          />
        )}
        {canViewWheel ? (
          <WheelsModule hideGlobalActions />
        ) : (
          <PlainMessage
            title={t('Wheel Preferences unavailable')}
            messages={[t('Your account does not have permission to view wheel preferences.')]}
          />
        )}
        {createActions.length > 0 && (
          <GlobalActions>
            <SpeedDial direction="up" actions={createActions} />
          </GlobalActions>
        )}
      </Container>
    </>
  );
}
